import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Eye = forwardRef<SVGSVGElement, SvgIconProps>(function Eye(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="M4.03 11.86c5.52-6.54 10.32-6.41 15.77.08-5.98 6.51-10.13 6.49-15.77-.08zm7.9-3.4a3.36 3.36 0 00-3.27 3.45c0 1.9 1.47 3.45 3.27 3.45s3.24-1.55 3.24-3.45c0-1.9-1.44-3.44-3.24-3.44zm1.96 3.45c0 1.08-.89 1.96-1.98 1.96a1.96 1.96 0 01-1.97-1.96c0-1.08.89-1.96 1.97-1.96 1.1 0 1.98.88 1.98 1.96z" />
    </SvgIcon>
  )
})

export default Eye
